import { formatMultiSelect } from "helpers/formatMultiSelect";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
} from "reactstrap";
import { TICKET_STATUS_OPTIONS } from "./utils";

const TicketStatusMultiFilter = ({
  selectedStatuses = [],
  onChange,
  label = "Trạng thái",
  primary = true,
  statusOptions: statusOptionsProp,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const statusOptions = useMemo(() => {
    const source = statusOptionsProp?.length
      ? statusOptionsProp
      : TICKET_STATUS_OPTIONS;

    return source.map(item => ({
      value: item.key ?? item.value,
      label: item.label,
    }));
  }, [statusOptionsProp]);

  const summaryLabel = useMemo(() => {
    const labels = selectedStatuses.map(statusKey => {
      const option = statusOptions.find(item => item.value === statusKey);

      return option?.label || statusKey;
    });

    return formatMultiSelect(labels);
  }, [selectedStatuses, statusOptions]);

  const toggleStatus = statusKey => {
    if (statusKey === "all") {
      onChange(undefined);

      return;
    }

    const isChecked = selectedStatuses.includes(statusKey);
    const nextStatuses = isChecked
      ? selectedStatuses.filter(item => item !== statusKey)
      : [...selectedStatuses, statusKey];

    onChange(nextStatuses.length ? nextStatuses : undefined);
  };

  return (
    <Dropdown
      className="d-inline-block align-middle mw-100"
      isOpen={isOpen}
      toggle={() => setIsOpen(prev => !prev)}
    >
      <DropdownToggle
        className={`btn ${primary ? "primary-btn" : ""} d-inline-flex align-items-center`}
        caret
        style={{
          width: "fit-content",
          maxWidth: "min(420px, calc(100vw - 24px))",
          whiteSpace: "nowrap",
        }}
      >
        {label}
        <span
          style={{
            display: "inline-block",
            maxWidth: "min(220px, 55vw)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "bottom",
          }}
        >
          :&nbsp;{summaryLabel}
        </span>
        <i className="mdi mdi-chevron-down" />
      </DropdownToggle>
      <DropdownMenu
        className="border shadow-sm w-100"
        style={{
          maxHeight: 320,
          overflowX: "hidden",
          overflowY: "auto",
          paddingTop: 6,
          paddingBottom: 6,
          scrollbarWidth: "thin",
        }}
      >
        <DropdownItem
          toggle={false}
          className="px-3 py-2 text-dark font-weight-medium"
          style={{ fontSize: "0.9375rem", cursor: "pointer" }}
          onClick={() => toggleStatus("all")}
        >
          Tất cả
        </DropdownItem>
        <DropdownItem divider />
        {statusOptions.map((item, index) => {
          const isChecked = selectedStatuses.includes(item.value);

          return (
            <DropdownItem
              toggle={false}
              key={`ticket-status-filter-${item.value}-${index}`}
              className="d-flex align-items-center px-3 py-2 text-dark"
              style={{ cursor: "pointer", whiteSpace: "normal" }}
              onClick={() => toggleStatus(item.value)}
            >
              <Input
                type="checkbox"
                className="form-check-input position-static flex-shrink-0 m-0"
                style={{
                  width: "1.125rem",
                  height: "1.125rem",
                  pointerEvents: "none",
                }}
                checked={isChecked}
                readOnly
                tabIndex={-1}
              />
              <span className="ms-2">{item.label}</span>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

TicketStatusMultiFilter.propTypes = {
  selectedStatuses: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  primary: PropTypes.bool,
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default TicketStatusMultiFilter;
